import script from "./MentionList.vue?vue&type=script&setup=true&lang=js"
export * from "./MentionList.vue?vue&type=script&setup=true&lang=js"

import "./MentionList.vue?vue&type=style&index=0&id=3b410310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b410310"]])

export default __exports__